module.exports = __webpack_public_path__ + "static/media/downPeriscope.dbf03516.webp";